(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(85138);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(61715);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/Lists/ReviewItem.jsx
var ReviewItem = __webpack_require__(74079);
// EXTERNAL MODULE: ./components/RecommendationsList/RecommendationItem/RecommendationItem.jsx
var RecommendationItem = __webpack_require__(82039);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./utils/httpClient.js
var httpClient = __webpack_require__(22550);
// EXTERNAL MODULE: ./pages/index.module.scss
var index_module = __webpack_require__(36697);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 31 modules
var esm = __webpack_require__(28147);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(16494);
// EXTERNAL MODULE: ./utils/checkUserCountry.js
var checkUserCountry = __webpack_require__(65024);
// EXTERNAL MODULE: ./components/OffersViews/OffersViews.jsx + 3 modules
var OffersViews = __webpack_require__(87302);
// EXTERNAL MODULE: ./utils/remoteAPI/offer.js
var offer = __webpack_require__(60960);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/createTheme.js + 13 modules
var styles_createTheme = __webpack_require__(98125);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(33636);
// EXTERNAL MODULE: ./node_modules/@material-ui/unstyled/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77828);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(16861);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Slide/Slide.js
var Slide = __webpack_require__(32867);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(69480);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/utils/capitalize.js
var capitalize = __webpack_require__(13353);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/createTransitions.js
var createTransitions = __webpack_require__(10577);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/useTheme.js
var useTheme = __webpack_require__(4662);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(57999);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/styled.js + 2 modules
var styled = __webpack_require__(83831);
// EXTERNAL MODULE: ./node_modules/@material-ui/unstyled/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(25664);
// EXTERNAL MODULE: ./node_modules/@material-ui/unstyled/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(30742);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/Drawer/drawerClasses.js

function getDrawerUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDrawer', slot);
}
const drawerClasses = (0,generateUtilityClasses/* default */.Z)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
/* harmony default export */ var Drawer_drawerClasses = ((/* unused pure expression or super */ null && (drawerClasses)));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/Drawer/Drawer.js


const _excluded = ["BackdropProps"],
      _excluded2 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];
















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};

const useUtilityClasses = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0,capitalize/* default */.Z)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0,capitalize/* default */.Z)(anchor)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getDrawerUtilityClass, classes);
};

const DrawerRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => ({
  zIndex: theme.zIndex.drawer
}));
const DrawerDockedRoot = (0,styled/* default */.ZP)('div', {
  shouldForwardProp: styled/* rootShouldForwardProp */.FO,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0,capitalize/* default */.Z)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0,capitalize/* default */.Z)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: theme.zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${theme.palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
const defaultTransitionDuration = {
  enter: createTransitions/* duration.enteringScreen */.x9.enteringScreen,
  exit: createTransitions/* duration.leavingScreen */.x9.leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

const Drawer = /*#__PURE__*/react.forwardRef(function Drawer(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDrawer'
  });

  const {
    anchor: anchorProp = 'left',
    BackdropProps,
    children,
    className,
    elevation = 16,
    hideBackdrop = false,
    ModalProps: {
      BackdropProps: BackdropPropsProp
    } = {},
    onClose,
    open = false,
    PaperProps = {},
    SlideProps,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Slide/* default */.Z,
    transitionDuration = defaultTransitionDuration,
    variant = 'temporary'
  } = props,
        ModalProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ModalProps, _excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  const theme = (0,useTheme/* default */.Z)(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  const mounted = react.useRef(false);
  react.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor(theme, anchorProp);
  const anchor = anchorProp;

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);

  const classes = useUtilityClasses(ownerState);

  const drawer = /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerPaper, (0,esm_extends/* default */.Z)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,clsx_m/* default */.Z)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));

  if (variant === 'permanent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }

  const slidingDrawer = /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));

  if (variant === 'persistent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  } // variant === temporary


  return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerRoot, (0,esm_extends/* default */.Z)({
    BackdropProps: (0,esm_extends/* default */.Z)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0,clsx_m/* default */.Z)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Drawer_Drawer = (Drawer);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(72276);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Tooltip/Tooltip.js + 3 modules
var Tooltip = __webpack_require__(68760);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(68914);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(86005);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Button/Button.js + 1 modules
var Button = __webpack_require__(38513);
// EXTERNAL MODULE: ./components/OfferDetails/OfferDetails.module.scss
var OfferDetails_module = __webpack_require__(35004);
var OfferDetails_module_default = /*#__PURE__*/__webpack_require__.n(OfferDetails_module);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AnnouncementOutlined.js
var AnnouncementOutlined = __webpack_require__(51983);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DescriptionOutlined.js
var DescriptionOutlined = __webpack_require__(40535);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/TravelExploreOutlined.js
var TravelExploreOutlined = __webpack_require__(24790);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ListAltOutlined.js
var ListAltOutlined = __webpack_require__(13056);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/IosShare.js
var IosShare = __webpack_require__(69773);
// EXTERNAL MODULE: ./components/ImageWithFallback/ImageWithFallback.jsx
var ImageWithFallback = __webpack_require__(74284);
// EXTERNAL MODULE: ./utils/setImageUrl.js
var setImageUrl = __webpack_require__(22670);
// EXTERNAL MODULE: ./components/FlightSearchResults/utils/flightUtils.js
var flightUtils = __webpack_require__(70231);
// EXTERNAL MODULE: ./node_modules/react-currency-format/lib/currency-format.js
var currency_format = __webpack_require__(95340);
var currency_format_default = /*#__PURE__*/__webpack_require__.n(currency_format);
// EXTERNAL MODULE: ./node_modules/currency-symbol-map/currency-symbol-map.js
var currency_symbol_map = __webpack_require__(81463);
var currency_symbol_map_default = /*#__PURE__*/__webpack_require__.n(currency_symbol_map);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./utils/cabinClasses.js
var cabinClasses = __webpack_require__(11723);
// EXTERNAL MODULE: ./components/utils/textEditorParseOptions.js
var textEditorParseOptions = __webpack_require__(5937);
;// CONCATENATED MODULE: ./components/OfferDetails/OfferDeatails.jsx































var FlightSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9989), __webpack_require__.e(2298), __webpack_require__.e(8423), __webpack_require__.e(9980), __webpack_require__.e(293), __webpack_require__.e(7522), __webpack_require__.e(5105), __webpack_require__.e(4648)]).then(__webpack_require__.bind(__webpack_require__, 75105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75105)
            ];
        }
    }
});
var getSimilarOffers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(origin, destination) {
        var url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "/api/offer/items?page=0&size=20&origin=".concat(origin, "&destination=").concat(destination, "&sort=price,asc");
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)(url)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getSimilarOffers(origin, destination) {
        return _ref.apply(this, arguments);
    };
}();
var theme = (0,styles_createTheme/* default */.Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#00454A"
        },
        dark: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
function OfferDetails(param) {
    var data = param.data, isOpen = param.isOpen, _closeDetails = param.closeDetails, closeDetails = _closeDetails === void 0 ? function() {} : _closeDetails, _showOrigin = param.showOrigin, showOrigin = _showOrigin === void 0 ? true : _showOrigin, searchSource = param.searchSource;
    var generateOffer = function generateOffer(offer, airline) {
        if (!offer) {
            return;
        }
        return {
            from: offer.origin.code,
            to: offer.destination.code,
            dateRange: {
                departure: offer.departureDate || null,
                return: offer.returnDate || null
            },
            cabinClass: offer.cabinClass,
            tripState: "round_trip",
            airlineType: airline,
            passengers: {
                adults: 1,
                children: 0
            }
        };
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)({
        open: false,
        offer: null
    }), shareDialogState = ref5[0], setShareDialogState = ref5[1];
    var ref6 = (0,react.useState)([]), similarOffers = ref6[0], setSimilarOffers = ref6[1];
    var ref7 = (0,react.useState)(0), mediaHeight = ref7[0], setMediaHeight = ref7[1];
    var ref8 = (0,react.useState)(0), mediaWidth = ref8[0], setMediaWidth = ref8[1];
    var ref9 = (0,react.useState)(data ? (0,_object_spread/* default */.Z)({}, data) : null), offer = ref9[0], setOffer = ref9[1];
    var imageRef = /*#__PURE__*/ (0,react.createRef)();
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var router = (0,next_router.useRouter)();
    console.log("data", data);
    (0,react.useEffect)(function() {
        if (imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) {
            setMediaHeight(imageRef.current.offsetWidth / 1.78);
            setMediaWidth(imageRef.current.offsetWidth);
        }
    }, [
        imageRef
    ]);
    (0,react.useEffect)(function() {
        console.log("offer", offer);
        if (offer) {
            getSimilarOffers(offer.origin.code, offer.destination.code).then(function(res) {
                setSimilarOffers((0,_to_consumable_array/* default */.Z)(res.content));
            });
            router.push({
                pathname: router.pathname,
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    offerid: offer.id
                })
            }, undefined, {
                shallow: true
            });
        }
    }, [
        offer
    ]);
    // useEffect(() => {
    //   if (offerId) {
    //     httpGet(`/api/offer/items/${offerId}`).then((res) => {
    //       if (!res.ok) {
    //         return;
    //       }
    //       setOffer({...res.json()});
    //     });
    //   }
    // }, [offerId]);
    var options = (0,textEditorParseOptions/* getTextEditorParseOptions */.G)({
        article: {},
        mediaWidth: mediaWidth,
        mediaHeight: mediaHeight,
        imageRef: imageRef,
        styles: (OfferDetails_module_default())
    });
    var isFlightSearchLink = function(offerLink) {
        if (!offerLink) {
            return false;
        }
        return offerLink.includes("searchRedirect");
    };
    var isDealsLink = function(offerLink) {
        if (!offerLink) {
            return false;
        }
        return offerLink.includes("dealsRedirect");
    };
    var generateDealsLink = function(offer) {
        return "/?country=".concat(offer.country.toUpperCase(), "&origin=").concat(offer.origin.code, "&destination=").concat(offer.destination.code, "&airline=").concat(offer.airline.code, "&airlineName=").concat(offer.airline.name, "&cabinClass=").concat(offer.cabinClass, "&currency=").concat(offer.currency);
    };
    var closeOfferDialog = function() {
        // setIsOfferDialogOpen(false);
        var query = (0,_object_spread/* default */.Z)({}, router.query);
        delete query.offerid;
        router.push({
            pathname: router.pathname,
            query: query
        }, undefined, {
            shallow: true
        });
        sessionStorage.setItem("BC-offerIDOpened", null);
        closeDetails(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer, {
                open: isOpen,
                onClose: function() {
                    return closeOfferDialog();
                },
                anchor: "right",
                ModalProps: {
                    disableAutoFocus: true,
                    disableEnforceFocus: true
                },
                sx: {
                    "& .MuiDrawer-paper": (0,_define_property/* default */.Z)({
                        width: "60%",
                        backgroundColor: "#FAF8F4"
                    }, theme.breakpoints.down("md"), {
                        width: "100%"
                    })
                },
                children: offer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((OfferDetails_module_default()).offerDialogContent, (OfferDetails_module_default()).offers, "p-3 lg:p-6 lg:pt-20 pt-16"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    color: "inherit",
                                    onClick: function() {
                                        return closeOfferDialog();
                                    },
                                    "aria-label": "close",
                                    className: (OfferDetails_module_default()).closeDialog,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-3xl w-full font-libre",
                                    children: "Offer details"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((OfferDetails_module_default()).offerDetailsContainer, "relative grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4"),
                            id: "offer-details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((OfferDetails_module_default()).offerDetailsImageContainer, "relative max-w-full"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* ImageWithFallback */.J, {
                                        src: (0,setImageUrl/* setImageUrl */.B)(offer === null || offer === void 0 ? void 0 : offer.image),
                                        layout: "fill",
                                        objectFit: "cover",
                                        alt: offer === null || offer === void 0 ? void 0 : (ref = offer.destination) === null || ref === void 0 ? void 0 : ref.name,
                                        quality: 95,
                                        sizes: "(max-width: 1024px) 100vw, 400px",
                                        className: "h-40"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((OfferDetails_module_default()).offerData, "w-full"),
                                    children: [
                                        ((ref1 = offer.airline) === null || ref1 === void 0 ? void 0 : ref1.code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferDetails_module_default()).offerOverline, "flex"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: classnames_default()((OfferDetails_module_default()).offerOverline, "w-full m-0 p-0 text-base"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-bold",
                                                            children: [
                                                                " ",
                                                                (0,flightUtils/* getCabinClass */.CP)(offer.cabinClass, false)
                                                            ]
                                                        }),
                                                        " | ",
                                                        offer.airline.name,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        offer.origin.name,
                                                        " (",
                                                        offer.origin.code,
                                                        ") -",
                                                        " ",
                                                        offer.destination.name,
                                                        " (",
                                                        offer.destination.code,
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (ref2 = offer.airline.logo) === null || ref2 === void 0 ? void 0 : ref2.replace("http", "https"),
                                                        width: 50,
                                                        height: 46,
                                                        loading: "lazy",
                                                        alt: "Airline logo",
                                                        className: "ml-auto"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: classnames_default()("font-fragment text-left my-5", showOrigin ? "text-2xl" : "text-3xl"),
                                            children: [
                                                showOrigin && (offer === null || offer === void 0 ? void 0 : (ref3 = offer.origin) === null || ref3 === void 0 ? void 0 : ref3.name) + " - ",
                                                offer === null || offer === void 0 ? void 0 : (ref4 = offer.destination) === null || ref4 === void 0 ? void 0 : ref4.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferDetails_module_default()).offerPrice, "text-2xl", !offer.regularPrice && "mb-4"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mr-2 text-base",
                                                    children: "From"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                    thousandSeparator: true,
                                                    displayType: "text",
                                                    prefix: currency_symbol_map_default()(offer === null || offer === void 0 ? void 0 : offer.currency) + " ",
                                                    value: Math.round(offer === null || offer === void 0 ? void 0 : offer.price),
                                                    className: "mr-2"
                                                })
                                            ]
                                        }),
                                        offer.regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-base mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: classnames_default()((OfferDetails_module_default()).regularPrice, "line-through mr-2 text-lg"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                        thousandSeparator: true,
                                                        displayType: "text",
                                                        prefix: currency_symbol_map_default()(offer.currency) + " ",
                                                        value: offer.regularPrice
                                                    })
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: classnames_default()((OfferDetails_module_default()).regularPrice, "text-lg"),
                                                    children: [
                                                        "(",
                                                        Math.round((offer.regularPrice - offer.price) / offer.regularPrice * 100) + "% off",
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isFlightSearchLink(offer.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: isDealsLink ? generateDealsLink(offer) : offer === null || offer === void 0 ? void 0 : offer.link,
                                            className: classnames_default()((OfferDetails_module_default()).offerLink, "mb-2"),
                                            target: "_blank",
                                            children: "View offer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferDetails_module_default()).offerOverline, "mb-2"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-lg",
                                                    children: [
                                                        "Offer expires:",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: moment_default()(offer === null || offer === void 0 ? void 0 : offer.expirationDate).format("DD.MM.YYYY")
                                                        })
                                                    ]
                                                }),
                                                ((offer === null || offer === void 0 ? void 0 : offer.departureDate) || (offer === null || offer === void 0 ? void 0 : offer.returnDate)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-lg",
                                                    children: [
                                                        "Travel dates:",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                moment_default()(offer === null || offer === void 0 ? void 0 : offer.departureDate).format("DD.MM.YYYY"),
                                                                " -",
                                                                " ",
                                                                moment_default()(offer === null || offer === void 0 ? void 0 : offer.returnDate).format("DD.MM.YYYY")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: "Share offer",
                                    placement: "top",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        color: "inherit",
                                        className: (OfferDetails_module_default()).shareIcon,
                                        onClick: function(event) {
                                            event.stopPropagation();
                                            event.preventDefault();
                                            setShareDialogState({
                                                open: true,
                                                offer: offer
                                            });
                                        },
                                        "aria-label": "close",
                                        sx: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginLeft: "5px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IosShare/* default */.Z, {
                                            className: "m-0 lg:h-6 lg:w-6 -mt-1"
                                        })
                                    })
                                })
                            ]
                        }),
                        isFlightSearchLink(offer.link) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((OfferDetails_module_default()).offerDetailsContainer, "mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelExploreOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Start offer flight search"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* default */.ZP, {
                                    triggerOnce: true,
                                    children: function(param) {
                                        var inView = param.inView, ref = param.ref;
                                        var ref1, ref2, ref3;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            ref: ref,
                                            className: "w-full",
                                            children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightSearch, {
                                                collapsed: false,
                                                disablePortal: true,
                                                airlineName: (ref1 = offer.airline) === null || ref1 === void 0 ? void 0 : ref1.name,
                                                airlineCode: (ref2 = offer.airline) === null || ref2 === void 0 ? void 0 : ref2.code,
                                                airlineClass: cabinClasses/* CABIN_CLASSES.find */.r.find(function(cabin) {
                                                    return cabin.value === offer.cabinClass;
                                                }).label,
                                                flightSearchValueProp: generateOffer(offer, (ref3 = offer.airline) === null || ref3 === void 0 ? void 0 : ref3.code),
                                                minDate: offer === null || offer === void 0 ? void 0 : offer.departureDate,
                                                maxDate: offer === null || offer === void 0 ? void 0 : offer.returnDate,
                                                defaultSortBy: "price",
                                                viewMode: width > 1600 ? "mainSearch" : "sideSearch",
                                                customHeader: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-sm font-semibold font-libre",
                                                    children: [
                                                        "Select your dates",
                                                        " ",
                                                        offer.departureDate && offer.returnDate && " between ".concat(moment_default()(offer === null || offer === void 0 ? void 0 : offer.departureDate).format("DD.MM.YYYY"), " and ").concat(moment_default()(offer === null || offer === void 0 ? void 0 : offer.returnDate).format("DD.MM.YYYY")),
                                                        " ",
                                                        "and click 'Find offer' to find flight details"
                                                    ]
                                                }),
                                                customSearchText: "Find offer",
                                                openInNewTab: true,
                                                searchSource: searchSource
                                            })
                                        });
                                    }
                                })
                            ]
                        }),
                        (similarOffers === null || similarOffers === void 0 ? void 0 : similarOffers.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListAltOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Similar offers"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4"),
                                    children: similarOffers.map(function(similarOffer) {
                                        var ref;
                                        return similarOffer.id !== offer.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((OfferDetails_module_default()).offerData, (OfferDetails_module_default()).offerDetailsContainer, "w-full cursor-pointer"),
                                            onClick: function() {
                                                var drawerContainer = document.querySelector(".MuiDrawer-paper");
                                                if (drawerContainer) {
                                                    drawerContainer.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth"
                                                    });
                                                }
                                                setOffer(null);
                                                setOffer(similarOffer);
                                                router.push({
                                                    pathname: router.pathname,
                                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                        offerid: similarOffer.id
                                                    })
                                                }, undefined, {
                                                    shallow: true
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()((OfferDetails_module_default()).offerOverline, "flex"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold block",
                                                            children: (0,flightUtils/* getCabinClass */.CP)(similarOffer.cabinClass, true)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "px-1",
                                                            children: "|"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                similarOffer.airline.name
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (ref = similarOffer.airline.logo) === null || ref === void 0 ? void 0 : ref.replace("http", "https"),
                                                            width: 25,
                                                            height: 20,
                                                            loading: "lazy",
                                                            alt: "Airline logo",
                                                            className: "ml-auto"
                                                        })
                                                    ]
                                                }),
                                                ((similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.departureDate) || (similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.returnDate)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (OfferDetails_module_default()).offerOverline,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                moment_default()(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.departureDate).format("DD.MM.YYYY"),
                                                                " ",
                                                                "-",
                                                                " ",
                                                                moment_default()(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.returnDate).format("DD.MM.YYYY")
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()((OfferDetails_module_default()).offerPrice, "text-xl mt-4"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "mr-2 text-base",
                                                            children: "From"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                            thousandSeparator: true,
                                                            displayType: "text",
                                                            prefix: currency_symbol_map_default()(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.currency) + " ",
                                                            value: Math.round(similarOffer === null || similarOffer === void 0 ? void 0 : similarOffer.price),
                                                            className: "mr-2"
                                                        })
                                                    ]
                                                }),
                                                similarOffer.regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-base",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classnames_default()((OfferDetails_module_default()).regularPrice, "line-through mr-2 text-base"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((currency_format_default()), {
                                                                thousandSeparator: true,
                                                                displayType: "text",
                                                                prefix: currency_symbol_map_default()(similarOffer.currency) + " ",
                                                                value: similarOffer.regularPrice
                                                            })
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: classnames_default()((OfferDetails_module_default()).regularPrice, "text-lg"),
                                                            children: [
                                                                "(",
                                                                Math.round((similarOffer.regularPrice - similarOffer.price) / similarOffer.regularPrice * 100) + "% off",
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, similarOffer.id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((OfferDetails_module_default()).offerDetailsContainer, "mb-4"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Offer description, terms and conditions"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: (0,html_react_parser/* default */.ZP)(offer.content, options)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (OfferDetails_module_default()).offerDetailsContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    className: "text-left font-libre",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementOutlined/* default */.Z, {
                                            className: "mr-2"
                                        }),
                                        " Important notes"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Amazing fares like these don’t last long - they can disappear within hours, or even minutes! If you don’t see similar prices to those listed above, try selecting different travel dates to find other great options. And don’t worry, we’ve got plenty more incredible deals coming your way very soon. Stay tuned!"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: shareDialogState.open && shareDialogState.offer,
                onBackdropClick: function() {
                    setShareDialogState({
                        open: false,
                        offer: null
                    });
                },
                PaperProps: {
                    style: {
                        position: "relative",
                        minWidth: "30vw"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        color: "inherit",
                        onClick: function() {
                            setShareDialogState({
                                open: false,
                                offer: null
                            });
                        },
                        "aria-label": "close",
                        className: (OfferDetails_module_default()).closeShareDialog,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (OfferDetails_module_default()).imageHeader,
                                children: shareDialogState.offer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* ImageWithFallback */.J, {
                                    src: (0,setImageUrl/* setImageUrl */.B)(shareDialogState.offer.image),
                                    width: 1200,
                                    height: 400,
                                    quality: 50,
                                    objectFit: "cover"
                                })
                            }),
                            shareDialogState.offer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: classnames_default()((OfferDetails_module_default()).imageTitle, "font-fragment font-normal text-xl lg:text-3xl"),
                                children: [
                                    shareDialogState.offer.origin.name,
                                    " - ",
                                    shareDialogState.offer.destination.name
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 mt-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-libre",
                                children: "Share this offer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        label: "Share url",
                                        variant: "outlined",
                                        defaultValue: "".concat("https://www.first-class.com").concat(router.asPath),
                                        className: "w-full",
                                        inputProps: {
                                            readOnly: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "contained",
                                        color: "secondary",
                                        sx: {
                                            backgroundColor: "#0a0a0a",
                                            color: "#ffffff",
                                            marginLeft: "1rem",
                                            textTransform: "none",
                                            minWidth: "100px",
                                            "&:hover": {
                                                backgroundColor: "#ffffff",
                                                color: "#0a0a0a"
                                            }
                                        },
                                        onClick: function() {
                                            navigator.clipboard.writeText("".concat("https://www.first-class.com").concat(router.asPath));
                                            setShareDialogState({
                                                open: false,
                                                offer: null
                                            });
                                        },
                                        children: "Copy link"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/index.jsx












// import Image from 'next/image';












// import LinearProgress from '@mui/material/LinearProgress';
// import Box from '@mui/material/Box'


// import CreditCardOffOutlinedIcon from '@mui/icons-material/CreditCardOffOutlined';
// import TrustpilotLogo from '../public/images/logos/trustpilot.svg';


// import { COUNTRIES } from '../config';



// import TrustPilotStars from '../public/images/logos/trustpilot-stars.svg'
// const News = dynamic(() => import('../components/News/News'));
var CallToSignUp = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8307), __webpack_require__.e(8746)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading Sign Up..."
        });
    }
});
var FeaturedContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5808).then(__webpack_require__.bind(__webpack_require__, 5808));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5808)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading Featured Content..."
        });
    }
});
// const DealsPage = dynamic(() => import('../components/DealsPage/Dealspage'), {
//   loading: () => <Box sx={{ width: '100%', backgroundColor: 'black' }}>
//   <LinearProgress color="secondary" />
// </Box>
// });
var getProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/user/profile")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getProfile() {
        return _ref.apply(this, arguments);
    };
}();
var pages_theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#ffffff"
        },
        secondary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var getFeaturedItems = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(paging) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/article?location=featured&page=".concat(paging.page, "&size=").concat(paging.pageSize))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getFeaturedItems(paging) {
        return _ref.apply(this, arguments);
    };
}();
var getVideo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var videoRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/video")
                    ];
                case 1:
                    videoRes = _state.sent();
                    return [
                        4,
                        videoRes.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getVideo() {
        return _ref.apply(this, arguments);
    };
}();
var getVideoMobile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var videoRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/video/mobile")
                    ];
                case 1:
                    videoRes = _state.sent();
                    return [
                        4,
                        videoRes.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getVideoMobile() {
        return _ref.apply(this, arguments);
    };
}();
// const getFeaturedFlights = async (country, origin) => {
//   const featuredFlightsDealsRes = await httpGet(
//     `/api/flight/deals?origin=${origin}&country=${country}&cabinClass=BIZ&size=6`
//   );
//   return await featuredFlightsDealsRes.json();
// };
// const getFeaturedOrigins = async (country) => {
//   const featuredFlightsDealsRes = await httpGet(
//     `/api/flight/popular/origin?country=${country}&cabinClass=BIZ`
//   );
//   return await featuredFlightsDealsRes.json();
// };
var getReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, airlineReviewRes, hotelReviewRes, destinationsListRes, airlineReview, hotelReview, destinationsList;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            (0,httpClient/* httpGet */.kA)("/api/airline/review?size=1&sort=random"),
                            (0,httpClient/* httpGet */.kA)("/api/hotel?size=1&sort=random"),
                            (0,httpClient/* httpGet */.kA)("/api/destinations?size=1&sort=random")
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), airlineReviewRes = ref[0], hotelReviewRes = ref[1], destinationsListRes = ref[2];
                    return [
                        4,
                        airlineReviewRes.json()
                    ];
                case 2:
                    airlineReview = _state.sent();
                    return [
                        4,
                        hotelReviewRes.json()
                    ];
                case 3:
                    hotelReview = _state.sent();
                    return [
                        4,
                        destinationsListRes.json()
                    ];
                case 4:
                    destinationsList = _state.sent();
                    return [
                        2,
                        {
                            airlineReview: airlineReview.content[0],
                            hotelReview: hotelReview.content[0],
                            destinationsList: destinationsList.content[0]
                        }
                    ];
            }
        });
    });
    return function getReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOfferById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(offerid) {
        var offerRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,httpClient/* httpGet */.kA)("/api/offer/items/".concat(offerid))
                    ];
                case 1:
                    offerRes = _state.sent();
                    if (offerRes.status >= 400) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        offerRes.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getOfferById(offerid) {
        return _ref.apply(this, arguments);
    };
}();
// Main page
// - Offer&Deal
//    example: http://localhost:4200?country=US&origin=NYC&destination=MLE&cabinClass=BIZ&currency=USD&date=2025-07-05&rdate=2025-07-12
// - SkyScanner:
//      - url includes utm_source=skyscanner
//      - prefill origin,destination,dates,persons
//    Example: origin=SYD&destination=LON&from-date=2025-09-10&to-date=2025-09-20&occupancy=2&utm_medium=cpc&utm_source=skyscanner&utm_campaign=standardunpriced
function Home(param) {
    var featured = param.featured, destinations = param.destinations, authCompleted = param.authCompleted;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var userStore = (0,es/* useSelector */.v9)(function(state) {
        return state.user.value;
    });
    // const [windowWidth, setWindowWidth] = useState(0);
    var ref1 = (0,react.useState)(null), video = ref1[0], setVideo = ref1[1];
    // const [cookieAccepted, setCookieAccepted] = useState(false);
    var ref2 = (0,react.useState)(0), searchBoxTab = ref2[0], setSearchBoxTab = ref2[1];
    var ref3 = (0,react.useState)(false), isVideo = ref3[0], setIsVideo = ref3[1];
    var ref4 = (0,react.useState)(null), airlineReview = ref4[0], setAirlineReview = ref4[1];
    var ref5 = (0,react.useState)(null), destinationsList = ref5[0], setDestinationsList = ref5[1];
    var ref6 = (0,react.useState)(null), hotelReview = ref6[0], setHotelReview = ref6[1];
    var ref7 = (0,react.useState)(featured.content), inspiration = ref7[0], setInspiration = ref7[1];
    var ref8 = (0,react.useState)(false), inspirationInfiniteLoop = ref8[0], setInspirationInfiniteLoop = ref8[1];
    var ref9 = (0,react.useState)({
        total: featured.totalElements,
        pageSize: featured.pageable.pageSize,
        page: featured.pageable.pageNumber
    }), inspirationPaging = ref9[0], setInspirationPaging = ref9[1];
    var ref10 = (0,react.useState)(false), isVideoFetched = ref10[0], setIsVideoFetched = ref10[1];
    var ref11 = (0,react.useState)(null), profileData = ref11[0], setProfileData = ref11[1];
    var ref12 = (0,react.useState)(null), defaultOrigin = ref12[0], setDefaultOrigin = ref12[1];
    var ref13 = (0,react.useState)(null), openedOffer = ref13[0], setOpenedOffer = ref13[1];
    var ref14 = (0,react.useState)(null), advLinkSearchData = ref14[0], setAdvLinkSearchData = ref14[1];
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var isMobile = width < 1024;
    var offerViewsDefaultOrigin = (0,react.useMemo)(function() {
        return advLinkSearchData ? {
            origin: advLinkSearchData.origin
        } : {
            origin: (userStore === null || userStore === void 0 ? void 0 : userStore.country) === (userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry) ? defaultOrigin : null,
            country: userStore === null || userStore === void 0 ? void 0 : userStore.country
        };
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.country,
        userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry,
        defaultOrigin,
        advLinkSearchData
    ]);
    (0,react.useEffect)(function() {
        if (!userStore || !userStore.country) return;
        // const withScroll = width + 17;
        // setWindowWidth(withScroll);
        // if (checkUserCountry(userStore?.country, userStore?.detectRegion)) {
        //   setVideo({image: '/images/night-sky.webp'});
        //   setIsVideo(false);
        //   setIsVideoFetched(false);
        //   return;
        // }
        // setVideo(null);
        if (!isVideoFetched || !video) {
            var fetchVideo = width < 1024 ? getVideoMobile : getVideo;
            fetchVideo().then(function(vid) {
                setVideo(vid);
                if (vid === null || vid === void 0 ? void 0 : vid.image.includes(".mp4")) {
                    setIsVideo(true);
                }
                setIsVideoFetched(true);
            });
        }
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.country
    ]);
    (0,react.useEffect)(function() {
        var updateOrigin = function(origin) {
            setDefaultOrigin(origin || ((userStore === null || userStore === void 0 ? void 0 : userStore.country) !== (userStore === null || userStore === void 0 ? void 0 : userStore.detectCountry) ? userStore === null || userStore === void 0 ? void 0 : userStore.country : userStore === null || userStore === void 0 ? void 0 : userStore.detectRegion));
        };
        if (userStore === null || userStore === void 0 ? void 0 : userStore.country) {
            (0,offer/* isCountryHasOffers */.TM)(userStore === null || userStore === void 0 ? void 0 : userStore.country).then(function(hasOffers) {
                if (!hasOffers) {
                    setDefaultOrigin(null);
                } else {
                    if (userStore === null || userStore === void 0 ? void 0 : userStore.userid) {
                        getProfile().then(function(profile) {
                            var ref, ref1;
                            setProfileData(profile);
                            updateOrigin(profile === null || profile === void 0 ? void 0 : (ref = profile.userAirports) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code);
                        });
                    } else {
                        var ref;
                        var preferredAirport = localStorage.getItem("BC_preferredAirport");
                        updateOrigin(preferredAirport ? (ref = JSON.parse(preferredAirport)) === null || ref === void 0 ? void 0 : ref.code : null);
                    }
                }
            });
        }
    }, [
        userStore === null || userStore === void 0 ? void 0 : userStore.userid,
        userStore === null || userStore === void 0 ? void 0 : userStore.country
    ]);
    (0,react.useEffect)(function() {
        // let cookieState = JSON.parse(localStorage.getItem('bcCookieConsentShowed'));
        // if (cookieState) {
        //   setCookieAccepted(cookieState);
        // } else {
        //   window.addEventListener('storage', () => {
        //     cookieState = JSON.parse(localStorage.getItem('bcCookieConsentShowed'));
        //     if (cookieState) {
        //       setCookieAccepted(cookieState);
        //     }
        //   });
        // }
        getReviews().then(function(res) {
            var airlineReview = res.airlineReview, hotelReview = res.hotelReview, destinationsList = res.destinationsList;
            setAirlineReview(airlineReview);
            setHotelReview(hotelReview);
            setDestinationsList(destinationsList);
        });
    }, []);
    (0,react.useEffect)(function() {
        if (!router.query) return;
        if (router.query["hotelsearch"]) {
            setSearchBoxTab(1);
        }
        if (router.query["offerid"]) {
            if (JSON.parse(sessionStorage.getItem("BC-offerIDOpened")) !== null) {
                return;
            }
            getOfferById(router.query["offerid"]).then(function(offer) {
                if (offer) {
                    setOpenedOffer(offer);
                }
            });
        }
        if (router.query["utm_source"] === "skyscanner") {
            var url = new URL(window.location.href);
            var params = url.searchParams;
            var origin = params.get("origin");
            var destination = params.get("destination");
            var from = params.get("from-date");
            var to = params.get("to-date");
            var passengers = +params.get("occupancy");
            if (origin && destination && from) {
                setAdvLinkSearchData({
                    origin: origin,
                    destination: destination,
                    from: from,
                    to: to,
                    passengers: passengers
                });
            }
        }
    }, [
        router
    ]);
    // useEffect(() => {
    //   if (!cookieAccepted) return;
    //   const script = document.createElement('script');
    //   script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5728937966944779";
    //   script.async = true;
    //   script.crossOrigin = "anonymous";
    //   document.body.appendChild(script);
    //   return () => {
    //     document.body.removeChild(script);
    //   };
    // }, [cookieAccepted]);
    (0,react.useEffect)(function() {
        if (inspirationPaging.page <= 3) {
            getFeaturedItems(inspirationPaging).then(function(res) {
                if (inspiration[0].title !== res.content[0].title) {
                    setInspiration((0,_to_consumable_array/* default */.Z)(inspiration).concat((0,_to_consumable_array/* default */.Z)(res.content)));
                } else {
                    setInspiration((0,_to_consumable_array/* default */.Z)(res.content));
                }
                if (inspirationPaging.page === 2) {
                    setInspirationInfiniteLoop(true);
                }
            }).catch(function(err) {
                console.log(err);
            });
        }
    }, [
        inspirationPaging
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: pages_theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "verify-admitad",
                        content: "7c7aa268bd"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((index_module_default()).topSection, (0,checkUserCountry/* checkUserCountry */.u)(userStore === null || userStore === void 0 ? void 0 : userStore.country, userStore === null || userStore === void 0 ? void 0 : userStore.detectRegion) && (index_module_default()).topSectionPattern),
                children: [
                    video && video.image && isVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                className: classnames_default()((index_module_default()).topBackground, "vjs-tech"),
                                src: "https://media.first-class.com/" + video.image.replace("/", ""),
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                playsInline: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((index_module_default()).topSectionText, "font-fragment"),
                                children: t("index.topSection")
                            })
                        ]
                    }),
                    video && video.image && !isVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            width > 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                // src={process.env.mediaUrl + video.image.replace('/', '')}
                                src: "https://media.first-class.com/" + ((ref = video.image) === null || ref === void 0 ? void 0 : ref.replace("/", "")),
                                className: classnames_default()((index_module_default()).topBackground, "vjs-tech"),
                                alt: "Top image",
                                layout: "fill",
                                objectFit: "cover",
                                objectPosition: "top center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((index_module_default()).topSectionText, "font-fragment", profileData && "text-3xl"),
                                children: [
                                    (profileData === null || profileData === void 0 ? void 0 : profileData.firstName) ? "Hi ".concat(profileData === null || profileData === void 0 ? void 0 : profileData.firstName, "! ") : "",
                                    t("index.topSection")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((index_module_default()).topSectionSearch, "container mx-auto"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SearchBox */.Rj, {
                            type: width && width < 1024 ? "sideSearch" : "mainSearch",
                            activeTab: searchBoxTab,
                            flightSearchValue: advLinkSearchData ? {
                                from: advLinkSearchData.origin,
                                to: advLinkSearchData.destination,
                                cabinClass: "BIZ",
                                dateRange: {
                                    departure: advLinkSearchData.from,
                                    return: advLinkSearchData.to
                                },
                                passengers: {
                                    adults: advLinkSearchData.passengers
                                },
                                tripState: "round_trip"
                            } : undefined,
                            // flightSearchValue={{
                            //   from: null,
                            //   to: null,
                            //   cabinClass: 'BIZ',
                            //   dateRange: {
                            //     departure: null,
                            //     return: null,
                            //   },
                            //   passengers: {
                            //     adults: 1,
                            //   },
                            //   tripState: 'round_trip',
                            // }}
                            searchSource: "Main search",
                            hotelSearchValue: {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((index_module_default()).trustSection, "container mx-auto"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).trustSectionContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_multi_carousel["default"], {
                                responsive: {
                                    mobile: {
                                        breakpoint: {
                                            max: 1024,
                                            min: 0
                                        },
                                        items: 1
                                    },
                                    desktop: {
                                        breakpoint: {
                                            min: 1025,
                                            max: 5000
                                        },
                                        items: 3
                                    }
                                },
                                arrows: false,
                                infinite: true,
                                draggable: isMobile,
                                showDots: false,
                                renderButtonGroupOutside: false,
                                renderDotsOutside: false,
                                autoPlay: isMobile,
                                swipeable: isMobile,
                                containerClass: (index_module_default()).carouselContainer,
                                itemClass: (index_module_default()).carouselItem,
                                ssr: true,
                                shouldResetAutoplay: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).trustItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).trustUsers,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/logos-mini/deal.png",
                                                    height: 40,
                                                    width: 35,
                                                    alt: "Trust by users icon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((index_module_default()).text),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-libre",
                                                        children: "Trusted by 5 million users"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Since 2021"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).trustItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).logos,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/images/logos-mini/kayak.png",
                                                        alt: "Kayak",
                                                        height: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/images/logos-mini/expedia-small.png",
                                                        alt: "Expedia",
                                                        height: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/images/logos-mini/booking.png",
                                                        alt: "Booking.com",
                                                        height: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/images/logos-mini/hotels-small.png",
                                                        alt: "Hotels.com",
                                                        height: 30
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).text,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-libre",
                                                        children: "Compare & Save"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Search, compare & book top fares from 100s of sites"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).trustItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).icon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/logos-mini/free-outline.png",
                                                    height: 40,
                                                    width: 35,
                                                    alt: "Free to use icon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_module_default()).text,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "font-libre",
                                                        children: "Completely Free to Use"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "No fees, no hidden charges — simply great deals"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            defaultOrigin && /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersViews/* OffersViews */.Y, {
                defaultOrigin: offerViewsDefaultOrigin,
                defaultDestination: advLinkSearchData ? {
                    destination: advLinkSearchData.destination
                } : undefined,
                backupOrigin: {
                    origin: "All origins",
                    country: userStore === null || userStore === void 0 ? void 0 : userStore.country
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                triggerOnce: true,
                children: function(param) {
                    var inView = param.inView, ref = param.ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: ref,
                        className: classnames_default()((index_module_default()).featuredContentWrapper),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((index_module_default()).featuredContent),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 lg:px-0",
                                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContent, {
                                            items: inspiration,
                                            enableInfinite: inspirationInfiniteLoop,
                                            executePaginate: function() {
                                                return setInspirationPaging((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inspirationPaging), {
                                                    page: inspirationPaging.page + 1
                                                }));
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-1/2 lg:w-1/4 mx-auto mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                            href: "/hotels/toplists",
                                            label: t("index.moreFinestSelection")
                                        })
                                    })
                                ]
                            })
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                triggerOnce: true,
                children: function(param) {
                    var inView = param.inView, ref = param.ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: ref,
                        className: classnames_default()((index_module_default()).content, "container"),
                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container flex flex-col lg:flex-row justify-center lg:mt-6 sm:mt-3 gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((index_module_default()).recommendationsList, "flex flex-col w-full lg:w-1/2 mr-4 order-2 lg:order-1"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).sameHeigtContainer,
                                            children: [
                                                destinationsList && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DestinationItem */.ex, {
                                                    item: destinationsList
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center items-center mt-6 mb-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-1/2 mx-auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                                            dark: true,
                                                            href: "/destinations?tab=destinations",
                                                            label: t("index.moreDestinations")
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        destinations.content.map(function(destination, index) {
                                            if (width && width < 1024 && index >= 1) {
                                                return;
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationItem/* RecommendationItem */.A, {
                                                item: destination
                                            }, destination.title);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center items-center my-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-1/2 mx-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                                    dark: true,
                                                    href: "/destinations?tab=articles",
                                                    label: t("index.moreGuides")
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-1 lg:order-2 flex flex-col w-full lg:w-1/2 mt-8 lg:mt-0 lg:ml-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).sameHeightContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (index_module_default()).review,
                                                    children: airlineReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* ReviewItem */.r, {
                                                        type: "Airline",
                                                        review: airlineReview,
                                                        url: "/airlines/reviews/".concat(airlineReview.textId)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center items-center mt-6 mb-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-1/2 mx-auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                                            dark: true,
                                                            href: "/airlines/reviews",
                                                            label: t("index.moreAirlineReviews")
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (index_module_default()).review,
                                            children: hotelReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem/* ReviewItem */.r, {
                                                type: "Hotel",
                                                starRating: true,
                                                review: hotelReview,
                                                url: "/hotel/review/".concat(hotelReview.textId)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center items-center my-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-1/2 mx-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* VintageButton */.Fz, {
                                                    dark: true,
                                                    href: "/hotels/reviews",
                                                    label: t("index.moreHotelReviews")
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            }),
            userStore && !userStore.userid && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                triggerOnce: true,
                children: function(param) {
                    var inView = param.inView, ref = param.ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        ref: ref,
                        className: "w-full mx-auto",
                        children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToSignUp, {
                            country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                            authCompleted: authCompleted,
                            sourcePage: "Index page bottom"
                        })
                    });
                }
            }),
            openedOffer && (openedOffer === null || openedOffer === void 0 ? void 0 : openedOffer.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferDetails, {
                isOpen: true,
                data: openedOffer,
                searchSource: "Main page link",
                closeDetails: function() {
                    setOpenedOffer(null);
                    sessionStorage.setItem("BC-offerIDOpened", null);
                }
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var pages = ((0,Layout/* withLayout */.X)(Home, true, false));


/***/ }),

/***/ 35004:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerData":"OfferDetails_offerData__phqbG","offerOverline":"OfferDetails_offerOverline__ed8aZ","airlineLogo":"OfferDetails_airlineLogo__8sGEI","offerPrice":"OfferDetails_offerPrice__A6QHP","regularPrice":"OfferDetails_regularPrice__FpnOu","offerLink":"OfferDetails_offerLink__CS0eU","closeDialog":"OfferDetails_closeDialog__Z0IZ3","closeShareDialog":"OfferDetails_closeShareDialog__A1oHL","offerDetailsContainer":"OfferDetails_offerDetailsContainer__gDKc8","shareIcon":"OfferDetails_shareIcon__LIyfT"};

/***/ }),

/***/ 36697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topSection":"index_topSection___KMiY","topSectionPattern":"index_topSectionPattern__dIhHb","topImage":"index_topImage__OVFb_","topBackground":"index_topBackground__peI5l","topSectionText":"index_topSectionText__u0WxX","topSectionSearch":"index_topSectionSearch__hYsWu","contentSearch":"index_contentSearch__3Byk6","callToSignUpContainer":"index_callToSignUpContainer__aeGTM","featuredContentWrapper":"index_featuredContentWrapper__gMn_C","featuredContent":"index_featuredContent__fM_ig","content":"index_content__k_CP2","tabs":"index_tabs__4O8kG","moreButton":"index_moreButton__ZGL6M","review":"index_review__J1F_f","recommendationsList":"index_recommendationsList__zFC6A","regionContentWrapper":"index_regionContentWrapper__mj2WW","regionContent":"index_regionContent__rUzRl","regionGlobeImage":"index_regionGlobeImage__Ve7Ga","regionTitle":"index_regionTitle__1YnWh","regionItem":"index_regionItem__FJ9Hn","regionName":"index_regionName__6_I2T","regionImage":"index_regionImage__YlPqz","regionPrice":"index_regionPrice___Pffd","heading":"index_heading__b7Ury","showDealsButton":"index_showDealsButton__TKV5t","trustSection":"index_trustSection__IiODw","trustSectionContainer":"index_trustSectionContainer___3Njg","carouselContainer":"index_carouselContainer__6Tb4p","carouselItem":"index_carouselItem__TojLG","trustItem":"index_trustItem__Iypgd","trustUsers":"index_trustUsers__4orj6","icon":"index_icon__pMy5N","logos":"index_logos__8PrTn","text":"index_text__MGPW5","trustpilot":"index_trustpilot__vwlxz","bounce":"index_bounce__H_GDi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4885,1255,3737,5316,2196,6163,4231,129,1979,7601,9125,3570,9113,2769,6700,632,9780,6420,4987,3766,6154,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);